export var FormFieldType;
(function (FormFieldType) {
    FormFieldType[FormFieldType["Checkbox"] = 0] = "Checkbox";
    FormFieldType[FormFieldType["TextField"] = 1] = "TextField";
    FormFieldType[FormFieldType["TextArea"] = 2] = "TextArea";
    FormFieldType[FormFieldType["RadioButton"] = 3] = "RadioButton";
    FormFieldType[FormFieldType["Select"] = 4] = "Select";
    FormFieldType[FormFieldType["MultiSelect"] = 5] = "MultiSelect";
    FormFieldType[FormFieldType["Numeric"] = 6] = "Numeric";
    FormFieldType[FormFieldType["Mask"] = 7] = "Mask";
    FormFieldType[FormFieldType["Password"] = 8] = "Password";
    FormFieldType[FormFieldType["Email"] = 9] = "Email";
})(FormFieldType || (FormFieldType = {}));
export var MaskType;
(function (MaskType) {
    MaskType[MaskType["Number"] = 0] = "Number";
    MaskType[MaskType["Text"] = 1] = "Text";
    MaskType[MaskType["Ranged"] = 2] = "Ranged";
})(MaskType || (MaskType = {}));
export var CartState;
(function (CartState) {
    CartState[CartState["Checkout"] = 0] = "Checkout";
    CartState[CartState["CheckoutForms"] = 1] = "CheckoutForms";
    CartState[CartState["Empty"] = 2] = "Empty";
    CartState[CartState["Processing"] = 3] = "Processing";
})(CartState || (CartState = {}));
//# sourceMappingURL=enums.js.map